export const participationDetailedFrame = () => ({
  id: 'participation-detailed-frame',
  name: 'Participation Detailed Frame',
  thumbnail: '/assets/diploma-templates/03_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/03_background.svg',
      key: null
    }
  }
});
